import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** MultiSelect property - Definition */
export class DocsBlockMultiSelectPropertyDefinition extends DocsBlockPropertyDefinition {
}
